<aside class="admin-sidebar">
  <!--     <a href="javascript:void(0);" class="sidebar-toggle"  (click)="onMobileToggaleSideBarOpen()" data-toggleclass="sidebar-open" data-target="body"> </a> -->

  <div class="admin-sidebar-brand">
    <img class="admin-brand-logo" src="../../../../assets/img/bidone-logo.png" alt="Logo">
    <div class="ml-auto">
      <a href="javascript:void(0);" class="sidebar-toggle" (click)="onMobileToggaleSideBarOpen()"
        data-toggleclass="sidebar-open" data-target="body">
      </a>
      <nav class="my-auto mr-auto ">
        <ul class="nav align-items-center">
          <li class="nav-item">
            <a class="nav-link sidebar-toggle sidebar sidebar-hamburger-toggle" (click)="onToggaleSideBar()"
              [class.is-open]="isSideBarOpen" data-target="javascript:void(0);siteSearchModal"
              data-toggle="modal" href="javascript:void(0);">
              <svg class="sidebar-hamburger-icon" xmlns="http://www.w3.org/2000/svg" width="19.273"
                height="16" viewBox="0 0 19.273 16" aria-hidden="true" focusable="false">
                <g transform="translate(-287.673 -47.5)">
                  <line x2="19.273" transform="translate(287.673 49)" fill="none"
                    stroke="currentColor" stroke-width="3" />
                    <line x2="19.273" transform="translate(287.673 55.5)" fill="none"
                      stroke="currentColor" stroke-width="3" />
                      <line x2="19.273" transform="translate(287.673 62)" fill="none"
                        stroke="currentColor" stroke-width="3" />
                      </g>
                    </svg>
                  </a>
                </li>
              </ul>
            </nav>
          </div>

        </div>
        <div class="admin-sidebar-wrapper js-scrollbar">
          <ul class="menu">
            @for (nav of sideMenuLinks; track nav; let i = $index) {
              <li routerLinkActive="active" id="left-menu-parent-{{i}}" class="menu-item openSubMenu">
                @if (nav.route) {
                  <a routerLink="{{nav.route}}" class="open-dropdown menu-link"
                    (click)="isOpen(nav.id)">
                    <span class="menu-icon">
                      <div [innerHTML]="nav.icon | safeHtml"></div>
                    </span>
                    <span class="menu-label"><span class="menu-name">{{nav.title}}</span></span>
                    @if (!isSideBarOpen) {
                      <span class="menu-icon">
                        <div [innerHTML]="nav.icon | safeHtml"></div>
                      </span>
                    }
                  </a>
                }
                @if (!nav.route) {
                  <a class="open-dropdown menu-link" (click)="isOpen(nav.id)">
                    <span class="menu-icon">
                      <div [innerHTML]="nav.icon | safeHtml"></div>
                    </span>
                    <span class="menu-label">
                      <span class="menu-name">
                        {{nav.title}}
                        @if (nav?.sublinks) {
                          <span class="menu-arrow-icon">
                            @if (nav.isSelected) {
                              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960"
                                width="24px" fill="#FF6600">
                                <path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z" />
                              </svg>
                            }
                            @if (!nav.isSelected) {
                              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960"
                                width="24px" fill="#FF6600">
                                <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" />
                              </svg>
                            }
                          </span>
                        }
                      </span>
                    </span>
                    @if (!isSideBarOpen) {
                      <span class="menu-icon">
                        <div [innerHTML]="nav.icon | safeHtml"></div>
                      </span>
                    }
                  </a>
                }
                @if (nav?.sublinks) {
                  <ul style="padding: 0px !important; display: block;" class="sub-menu" [@expandCollapse]="(nav.isSelected && isSideBarOpen) ? 'open' : 'closed'" id={{nav.id}}
                    >
                    @for (sub of nav?.sublinks; track sub; let j = $index) {
                      <li routerLinkActive="activeSubMenu" id="left-menu-child-{{i}}" class="menu-item "
                        >
                        <a routerLink={{sub.route}} class=" menu-link">
                          <span class="menu-label">
                            <span class="pl-2 menu-name">{{sub.title}}</span>
                          </span>
                        </a>
                      </li>
                    }
                  </ul>
                }
              </li>
            }
          </ul>
        </div>
      </aside>